import React from 'react'
import styled from 'react-emotion'
import { connect } from 'react-redux'
import { firebaseConnect, getVal } from 'react-redux-firebase'
import { compose, setStatic } from 'recompose'
import { Avatar } from './Avatar'
import Text from './Text'
import { space } from '../style'

export const User = styled(({ name, small, className }) => (
  <div className={className}>
    <Avatar name={name} />
    <Text bold small={small}>
      {name}
    </Text>
  </div>
))({
  label: 'User',
  display: 'flex',
  alignItems: 'center',
  [Avatar.className]: {
    marginRight: space.default
  }
})

const UserContainer = compose(
  firebaseConnect(({ userId }) => [`/users/public/${userId}`]),
  connect((state, { userId }) => {
    const user = getVal(state.firebase, `data/users/public/${userId}`)
    return {
      name: user && user.displayName
    }
  }),
  setStatic('className', User.toString())
)

export default UserContainer(User)
